import React from 'react';
import  { VentureAccountInfoComponent } from './venture-account-info.component';
import { AddressContainer } from '../../../../common/address/containers/address.container';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import  { VentureUserProfileInfoComponent } from './venture-userProfile.component';
import VentureBasicInfoComponent from './add-venture.components';
import VentureLoginInfoComponent from './venture-login-info.component';
import SubscriptionContainer from './subscription-container';
import BusinessDetailsContainer from './businessdetails-container';


export const VentureComponent = ({ accounts,selectedVenture,id,selectedAccounts, handleInnerFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Venture-Info',
            component: (
                <VentureBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedAccounts={selectedAccounts}
                />
            ),
            isVisible: id === String(0) ? true : false,
        },
        {
            id: 2,
            title: 'Login-Info',
            component: (
                <VentureLoginInfoComponent
                onInnerFormChange={handleInnerFormChange}
                selectedVenture ={selectedVenture}
                />
            ),
            isVisible:id > 0 ? true : false
        },
        {
            id: 3,
            title: 'User-Info',
            component: (
                <VentureUserProfileInfoComponent
                onInnerFormChange ={handleInnerFormChange}
                selectedVenture={selectedVenture}
                />
            ),
            isVisible:id > 0 ? true : false
        },
    
        {
            id: 4,
            title: 'Account-Info',
            component: (
                <VentureAccountInfoComponent
                accounts={accounts} 
                onInnerFormChange={handleInnerFormChange} 
                selectedVenture={selectedVenture}
                />
            ),
            isVisible:id > 0 ? true : false
        }, 
        {
            id: 5,
            title: 'Address-Info',
            component: (
                <AddressContainer
                onInnerFormChange={handleInnerFormChange}
                selectedAddress={selectedVenture}
                />
               
            ),
            isVisible:id > 0 ? true : false
        },
          {
            id: 6,
            title: 'Business Details',
            component: (
                <BusinessDetailsContainer
       
               selectedVenture={selectedVenture}
                />
               
            ),
            isVisible:id > 0 ? true : false
        },
        {
            id: 7,
            title: 'Subscriptions',
            component: (
                <SubscriptionContainer
       
               selectedVenture={selectedVenture}
                />
               
            ),
            isVisible:id > 0 ? true : false
        },
       
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default VentureComponent;
